export const TestimonialData = [
    {
        TextClinet:`“Working with Chris is to give a good 
        impression, I carry out my project at a good 
        cost, with excellent quality and attention. 
        Great service and recommended.”`,
        NameClinet:'احمد عزوز',
        Clinet:'عميل'
    },
    {
        TextClinet:`“Working with Chris is to give a good 
        impression, I carry out my project at a good 
        cost, with excellent quality and attention. 
        Great service and recommended.”`,
        NameClinet:'محمد عزوز',
        Clinet:'عميل'
    },
    {
        TextClinet:`“Working with Chris is to give a good 
        impression, I carry out my project at a good 
        cost, with excellent quality and attention. 
        Great service and recommended.”`,
        NameClinet:'عمار عزوز',
        Clinet:'عميل'
    },
    {
        TextClinet:`“Working with Chris is to give a good 
        impression, I carry out my project at a good 
        cost, with excellent quality and attention. 
        Great service and recommended.”`,
        NameClinet:'يوسف عزوز',
        Clinet:'عميل'
    },
]